import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import enLocale from "./en";
import viLocale from "./vi";
import jaLocale from "./ja";
import msLocale from "./ms";

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale
  },
  vi: {
    ...viLocale
  },
  ja: {
    ...jaLocale
  },
  ms: {
    ...msLocale
  }
};

const i18n = new VueI18n({
  // set locale
  // options: en | vi | ja
  locale: Cookies.get("language") || "en",
  // set locale messages
  messages
});

export default i18n;
